import { signalMoves } from './moves-signal'
import { stageMoves } from './moves-stage'
import type { Move } from './move-types'

const catalog = { ...stageMoves, ...signalMoves }

export const mascotMoves: { [K in keyof typeof catalog]: Move } = catalog
export type MascotMove = keyof typeof mascotMoves
